<template>
  <div class="benchmark-gauge">
    <div class="benchmark-gauge__header">
      <h3 class="benchmark-gauge__title">{{ title }}</h3>
    </div>

    <div class="benchmark-gauge__content">
      <div class="benchmark-gauge__chart">
        <theme-gauge-chart
          :value="benchmarkValue"
          :min="-100"
          :max="100"
          :green-zone="[-100, -5]"
          :yellow-zone="[-5, 5]"
          :red-zone="[5, 100]"
          :show-labels="true"
        />
      </div>
      
      <div class="benchmark-gauge__status">
        <span v-if="benchmarkValue !== 0">Currently</span>
        <span class="benchmark-gauge__badge" :class="benchmarkBadgeClass">
          {{ benchmarkLabel }}
        </span>
        <span v-if="benchmarkValue !== 0">{{ overUnder }} Market</span>
      </div>

      <div v-if="showWarning" class="benchmark-gauge__warning">
        Concerning - Above Market
      </div>

      <div class="benchmark-gauge__subtitle">
        PORTFOLIO VS MARKET RATE
      </div>
    </div>
  </div>
</template>

<script>
import ThemeGaugeChart from './charts/ThemeGaugeChart.vue';

export default {
  name: 'BenchmarkGauge',

  components: {
    ThemeGaugeChart
  },

  props: {
    title: {
      type: String,
      default: 'Project Benchmark to Market'
    },
    height: {
      type: String,
      default: '250'
    },
    benchmark: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    benchmarkValue() {
      return parseFloat(this.benchmark) || 0;
    },

    benchmarkLabel() {
      if (this.benchmarkValue === 0) return 'AT MARKET';
      return Math.abs(this.benchmarkValue) + '%';
    },

    benchmarkBadgeClass() {
      if (this.benchmarkValue > 0) return 'benchmark-gauge__badge--over';
      if (this.benchmarkValue < 0) return 'benchmark-gauge__badge--under';
      return 'benchmark-gauge__badge--at';
    },

    overUnder() {
      return this.benchmarkValue > 0 ? 'Over' : 'Under';
    },

    showWarning() {
      return this.benchmarkValue > 20;
    }
  }
};
</script>
